@let items = entities();
<section class="px-xs !py-lg h-full bg-white" hlmCard>
  <div class="px-md flex items-center justify-between">
    <div class="grid">
      <h3 hlmCardTitle>Liste des trigrammes type de certification</h3>
      <p class="text-content-secondary">
        Impossible de supprimer ou modifier un trigramme s'il est associé à une certification lié à une étape.
      </p>
    </div>
    <div class="gap-sm flex" hlmCardAction>
      <button (click)="ajouterTrigramme()" hlmBtn variant="secondary">
        <ng-icon name="lucidePlus" />
        Créer un nouveau trigramme
      </button>
      <button (click)="export()" hlmBtn variant="secondary">
        <ng-icon name="lucideDownload" />
        Exporter les trigrammes
      </button>
    </div>
  </div>

  @if (items.length) {
    <div hlmCardContent>
      <div hlmTableContainer>
        <table hlmTable>
          <thead hlmTHead>
            <tr hlmTr>
              <th hlmTh>Nom</th>
              <th hlmTh>Trigramme</th>
              <th hlmTh>Actions</th>
            </tr>
          </thead>
          <tbody hlmTBody>
            @for (item of items; track item.id) {
              <tr hlmTr>
                <td class="text-decoration-underline" [hlmTooltipTrigger]="item.nom" hlmTd>{{ item.nom }}</td>
                <td hlmTd>{{ item.code }}</td>
                <td hlmTd>
                  <button
                    [disabled]="item.estUtilise"
                    (click)="edit(item)"
                    aria-label="Éditer le trigramme"
                    hlmBtn
                    variant="ghost"
                    size="icon"
                    hlmTooltipTrigger="Éditer le trigramme"
                  >
                    <ng-icon name="lucidePen" />
                  </button>
                  <button
                    [disabled]="item.estUtilise"
                    (click)="delete(item.id)"
                    aria-label="Supprimer le trigramme"
                    hlmBtn
                    variant="ghost"
                    size="icon"
                    hlmTooltipTrigger="Supprimer le trigramme"
                  >
                    <ng-icon name="lucideTrash" />
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <app-paginateur [store]="trigrammeStore" />
    </div>
  }
</section>
